export default __webpack_public_path__ + "static/media/login.bd994738.jpg";